import Field from './Field';
import ReactStrapComponent from './ReactStrapComponent';

const PasswordField = (props) => (
  <Field type="password" component={ReactStrapComponent} {...props} />
);

export default PasswordField;
